import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	title: {
		color: theme.body.foreground.color.default,
	},
	priceTable: {
		display: 'flex',
		flex: '1 0 auto',
		flexDirection: 'column',
		borderCollapse: 'collapse',
		width: '100%',
		padding: `${theme.spacing.small} 0`,
		borderTop: theme.divider.border,

		'& th': {
			textAlign: 'left',
		},
	},
	tableBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
		padding: `${theme.spacing.small} 0`,
		borderBottom: theme.divider.border,

		'& tr': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		'& td': {
			alignSelf: 'start',
		},
	},
	capitalize: {
		'&:first-letter': {
			textTransform: 'capitalize',
		},
	},
	positivePrice: {
		color: theme.positive.color.default,
		fontWeight: theme.weight.semibold,
	},
	subItem: {
		color: theme.palette.neutral[50],
	},
	centeredRow: {
		'& td': { alignSelf: 'center' },
	},
}));
